import gsap from 'gsap'

// UTILITY FUNCTIONS
function $(className) {
    return document.querySelector(`.${className}`)
}
function $$(id) {
    return document.querySelector(`#${id}`)
}

// blend two hex colors together by an amount
// https://stackoverflow.com/questions/6367010/average-2-hex-colors-together-in-javascript/56348573#56348573
function blendColors(colorA, colorB, amount) {
    const [rA, gA, bA] = colorA.match(/\w\w/g).map((c) => parseInt(c, 16));
    const [rB, gB, bB] = colorB.match(/\w\w/g).map((c) => parseInt(c, 16));
    const r = Math.round(rA + (rB - rA) * amount).toString(16).padStart(2, '0');
    const g = Math.round(gA + (gB - gA) * amount).toString(16).padStart(2, '0');
    const b = Math.round(bA + (bB - bA) * amount).toString(16).padStart(2, '0');
    return '#' + r + g + b;
}

// SELECTIONS
const greenTank = $('green-resource-tank')
const blueTank = $('blue-resource-tank')
const pinkTank = $('pink-resource-tank')
const purpleTank = $('purple-resource-tank')

const greenTankRect = $('green-tank-rect')
const blueTankRect = $('blue-tank-rect')
const pinkTankRect = $('pink-tank-rect')
const purpleTankRect = $('purple-tank-rect')

const greenTankT = $('flavour-color-t')
const blueTankT = $('water-product-t')
const pinkTankT = $('spirit-additive-t')
const purpleTankT = $('mixrite-product-t')

// Dosing Pumps
const dosingPump1 = $('fan-1')
const pump1Wings = $('outer-fan-wings-g_4')
const dosingPumpT1 = $('dosing-pump-t-1')

const dosingPump2 = $('fan-2')
const pump2Wings = $('outer-fan-wings-g_3')
const dosingPumpT2 = $('dosing-pump-t-2')

const dosingPump3 = $('fan-3')
const pump3Wings = $('outer-fan-wings-g_2')
const dosingPumpT3 = $('dosing-pump-t-3')

const dosingPump4 = $('fan-4')
const pump4Wings = $('outer-fan-wings-g')
const dosingPumpT4 = $('dosing-pump-t-4')


const heading = $('heading')
const recirculationLineT = $('recirculation-line-t')
const fillingLineT = $('filling-line-t')


// Pipes
const mixerExitPipeOuter = $('mixer-exit-pipe-outer')
const mixerExitPipeInner = $('mixer-exit-pipe-inner')

const fillLinePipeOuter = $('fill-line-pipe-outer')
const fillLinePipeInner = $('fill-line-pipe-inner')

const reEntryPipeInner = $('re-entry-pipe-inner')
const reEntryPipeOuter = $('re-entry-pipe-outer')

const pinkPipeInner = $('pink-pipe-inner')
const pinkPipeOuter = $('pink-pipe-outer')

const bluePipeInner = $('blue-pipe-inner')
const bluePipeOuter = $('blue-pipe-outer')

const greenPipeInner = $('green-pipe-inner')
const greenPipeOuter = $('green-pipe-outer')


// Flows
const blueFlow = $('blue-flow')
const greenFlow = $('green-flow')
const pinkFlow = $('pink-flow')
const purpleFlow = $('purple-flow')
const mixerExitFlow = $('mixer-exit-flow')
const exitFillFlow = $('exit-fill-flow')

const mixerCover = $('mixer-cover')
const mixingFlowLines = [
    $('b-1'),
    $('b-2'),
    $('b-3'),
    $('middle-0'),
    $('t-1'),
    $('t-2'),
    $('t-3')
]
const linearGradientofFlowLines = [
  $('paint0_linear').firstChild,
  $('paint1_linear').firstChild,
  $('paint2_linear').firstChild,
  $('paint3_linear').firstChild,
  $('paint4_linear').firstChild,
  $('paint5_linear').firstChild,
  $('paint6_linear').firstChild,
]
const finalColor = linearGradientofFlowLines[0].nextSibling.getAttributeNode('stop-color').nodeValue
console.log(finalColor)

// ANIMATION UTILITY FUNCTIONS
function drawSVG(path, drawingDuration = 2, positionParameter = '', ease = 'power4.out') {
    const l = path.getTotalLength()
    const tl = new gsap.timeline()
    tl.set(path, {strokeDasharray: l}).fromTo(path, {
        strokeDashoffset: l,
        opacity: 0
    }, {
        strokeDashoffset: 0,
        duration: drawingDuration,
        opacity: 1,
        ease: ease
    }, positionParameter);
    return tl
}

function curvedDrawingSVGAndStrokeAnimation(path, duration = 10, strokeDasharray = '4 4', reverse = false) {
    const tl = new gsap.timeline()
    drawSVG(path, reverse)

    if (! reverse) {
        tl.to(path, {
            strokeDasharray: strokeDasharray,
            strokeOpacity: 0.5,
            ease: 'power4.out',
            duration: 0.2
        }, 'dashes+=1').fromTo(path, {
            strokeDashoffset: path.getTotalLength()
        }, {
            strokeDashoffset: 0,
            ease: 'linear',
            repeat: -1,
            duration: duration
        }, '>')

    } else {
        tl.to(path, {
            strokeDasharray: strokeDasharray,
            strokeOpacity: 0.5,
            ease: 'power4.out',
            duration: 0.2
        }, 'dashes+=1').fromTo(path, {
            strokeDashoffset: 0
        }, {
            strokeDashoffset: path.getTotalLength(),
            ease: 'linear',
            repeat: -1,
            duration: duration
        }, '>')
    }

    return tl
}

function alphaAnimation(element, drawingDuration = 2, ease = 'sine', positionParameter = ''){
    const tl = new gsap.timeline()
    tl
      .fromTo(element, {
        opacity: 0
      }, {
        duration: drawingDuration,
        opacity: 1,
        ease: ease
      }, positionParameter);
    return tl
}

// https://greensock.com/forums/topic/21618-remove-an-element-at-end-of-tween/
function removeElement(element) {
    if (typeof(element) === "string") {
        element = document.querySelector(element);
    }
    return function () {
        element.parentNode.removeChild(element);
    };
}


// ANIMATIONS
function setThings() {
    const tl = new gsap.timeline()
    tl.set([
        greenTank,
        blueTank,
        pinkTank,
        purpleTank,
        greenTankT,
        blueTankT,
        pinkTankT,
        fillingLineT,
        purpleTankT,
        dosingPump1,
        // pump1Wings,
        dosingPumpT1,
        dosingPump2,
        // pump2Wings,
        dosingPumpT2,
        dosingPump3,
        // pump3Wings,
        dosingPumpT3,
        dosingPump4,
        // pump4Wings,
        dosingPumpT4,
        heading,
        recirculationLineT,
        mixerExitPipeOuter,
        mixerExitPipeInner,
        fillLinePipeOuter,
        fillLinePipeInner,
        reEntryPipeInner,
        reEntryPipeOuter,
        pinkPipeInner,
        pinkPipeOuter,
        bluePipeInner,
        bluePipeOuter,
        greenPipeInner,
        greenPipeOuter,
        blueFlow,
        greenFlow,
        pinkFlow,
        purpleFlow,
        mixerCover,
        mixerExitFlow,
        exitFillFlow,
        ... mixingFlowLines,
    ], {opacity: 0})
    .set(purpleTankRect, {attr:{y: 320}})
    return tl
}
function entry() {
    const tl = new gsap.timeline
    tl.fromTo([
        greenTank,
        blueTank,
        pinkTank,
        mixerCover,
        purpleTank
    ], {
        opacity: 0,
        y: -5,
        ease: 'sine',
        duration: 1
    }, {
        stagger: 0.1,
        opacity: 1,
        y: 0
    }).fromTo([
        greenTankT,
        blueTankT,
        pinkTankT,
        heading,
        purpleTankT
    ], {
        y: 10,
        opacity: 0
    }, {
        opacity: 1,
        y: 0,
        stagger: 0.2
    }, "-=2")
    return tl
}
function pipeCreations() {
    const tl = new gsap.timeline()
    drawSVG(bluePipeInner, 2, '')
    drawSVG(bluePipeOuter, 2, '')

    drawSVG(greenPipeOuter, 2, '+1')
    drawSVG(greenPipeInner, 2, '+1')

    drawSVG(pinkPipeOuter, 2, '+1.5')
    drawSVG(pinkPipeInner, 2, '+1.5')

    drawSVG(mixerExitPipeOuter, 2, '+2.5')
    drawSVG(mixerExitPipeInner, 2, '+2.5')

    drawSVG(reEntryPipeOuter, 2, '+4')
    drawSVG(reEntryPipeInner, 2, '+4')

    drawSVG(fillLinePipeOuter, 2, '+3', 'sine')
    drawSVG(fillLinePipeInner, 2, '+4', 'sine')
    tl.fromTo(recirculationLineT, {
      opacity: 0,
      y: 10
    }, {
      opacity: 1,
      ease: 'sine',
      y:0
    }, '+5')

    return tl
}
function pipeAppearance(){
    const tl = new gsap.timeline()
    alphaAnimation(bluePipeInner, 2, '')
    alphaAnimation(bluePipeOuter, 2, '')

    alphaAnimation(greenPipeOuter, 2, '+1')
    alphaAnimation(greenPipeInner, 2, '+1')

    alphaAnimation(pinkPipeOuter, 2, '+1.5')
    alphaAnimation(pinkPipeInner, 2, '+1.5')

    alphaAnimation(mixerExitPipeOuter, 2, '+2.5')
    alphaAnimation(mixerExitPipeInner, 2, '+2.5')

    alphaAnimation(reEntryPipeOuter, 2, '+4')
    alphaAnimation(reEntryPipeInner, 2, '+4')

    alphaAnimation(fillLinePipeOuter, 2, '+3', 'sine')
    alphaAnimation(fillLinePipeInner, 2, '+4', 'sine')
    tl.fromTo(recirculationLineT, {
      opacity: 0,
      y: 5
    }, {
      opacity: 1,
      ease: 'sine',
      y:0
    }, '+0.4')

    return tl
}
function pumpStarts() {
    const tl = new gsap.timeline()
    tl.fromTo([
        dosingPump1, dosingPump2, dosingPump3, dosingPump4
    ], {
        opacity: 0,
        y: -5
    }, {
        opacity: 1,
        y: 0,
        ease: 'sine',
        stagger: 0.1
    }).fromTo([
        dosingPumpT1, dosingPumpT2, dosingPumpT3, dosingPumpT4
    ], {
        opacity: 0,
        x: -5
    }, {
        opacity: 1,
        x: 0,
        ease: 'sine',
        duration: 1,
        stagger: 0.1
    }, '')
    return tl
}
function flowStart() {
    const tl = new gsap.timeline()
    tl.fromTo(pump2Wings, {
        rotate: '0deg',
        transformOrigin: 'center center'
    }, {
        repeat: -1,
        duration: 2,
        rotate: '-360deg',
        ease: 'linear'
    }, "+=1")
    .fromTo(blueFlow, {
        strokeDasharray: "0 0",
        opacity: 0,
        duration: 0.5,
        attr: {
            d: "M39 201"
        }
    }, {
        opacity: 1,
        attr: {
            d: "M39 201v21"
        }
    }, '-=1')
    .to(blueFlow, {
        attr: {
            d: "M39 201v21h273"
        },
        strokeDasharray: '2 2',
        duration: 5
    }, '>')
    .fromTo(blueFlow, {
        strokeDashoffset: blueFlow.getTotalLength()
    }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 10
    }, '>')

    
    .fromTo(pump1Wings, {
      rotate: '0deg',
      transformOrigin: 'center center'
    }, {
        repeat: -1,
        duration: 2,
        rotate: '-360deg',
        ease: 'linear'
    }, "+2")
    .fromTo(greenFlow, {
        strokeDasharray: "0 0",
        opacity: 0,
        duration: 0.5,
        attr: {
            d: "M182 106"
        }
    }, {
        opacity: 1,
        attr: {
            d: "M182 106v23"
        }
    })
    .to(greenFlow, {
        attr: {
            d: "M182 106v23h61"
        },
        duration: 0.5
    }, '>')
    .to(greenFlow, {
        attr: {
            d: "M182 106v23h61v93"
        },
        duration: 0.5
    }, '>')
    .to(greenFlow, {
        attr: {
            d: "M182 106v23h61v93h69"
        },
        strokeDasharray: '2 2',
        duration: 1
    }, '>')
    .fromTo(greenFlow, {
        strokeDashoffset: greenFlow.getTotalLength()
    }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 10
    }, '>')


    .fromTo(pump3Wings, {
      rotate: '0deg',
      transformOrigin: 'center center'
    }, {
        repeat: -1,
        duration: 2,
        rotate: '-360deg',
        ease: 'linear'
    }, "+2")
    .fromTo(pinkFlow, {
        strokeDasharray: "0 0",
        opacity: 0,
        duration: 0.5,
        attr: {
            d: "M182 343"
        }
    }, {
        opacity: 1,
        attr: {
            d: "M182 343v18"
        }
    })
    .to(pinkFlow, {
        attr: {
            d: "M182 343v18h85"
        },
        duration: 0.5
    }, '>')
    .to(pinkFlow, {
        attr: {
            d: "M182 343v18h85v-139"
        },
        duration: 0.5
    }, '>')
    .to(pinkFlow, {
        attr: {
            d: "M182 343v18h85v-139h45"
        },
        strokeDasharray: '2 2',
        duration: 1
    }, '>')
    .fromTo(pinkFlow, {
        strokeDashoffset: pinkFlow.getTotalLength()
    }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 10
    }, '>')

    return tl
}
function mixingLines() {
    const tl = new gsap.timeline()
    drawSVG(mixingFlowLines[0], 4, '', 'power3.in')
    drawSVG(mixingFlowLines[1], 4.15, '', 'power4.in')
    drawSVG(mixingFlowLines[2], 4.2, '', 'expo.in')
    drawSVG(mixingFlowLines[3], 4.1, '', 'power3.in')
    drawSVG(mixingFlowLines[4], 4, '', 'power4.in')
    drawSVG(mixingFlowLines[5], 4.2, '', 'power4.in')
    drawSVG(mixingFlowLines[6], 4.2, '', 'expo.in')
    .set(mixingFlowLines, {
        strokeDasharray: '2 2',
        ease: 'power4.out',
        duration: 0.1
    })
    .fromTo(mixingFlowLines, {
        strokeDashoffset: mixingFlowLines[0].getTotalLength()
    }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 20
    }, '>')
    return tl
}
function exitFlow(){
  const tl = new gsap.timeline()
  tl
    .fromTo(mixerExitFlow, {
      strokeDasharray: "0 0",
      opacity: 0,
      duration: 0.5,
      attr: {
          d: "M556 222"
      }
    }, {
        opacity: 1,
        attr: {
            d: "M556 222h65"
        }
    })
    .to(mixerExitFlow, {
        attr: {
            d: "M556 222h65v18.5"
        },
        strokeDasharray: '2 2',
        duration: 1
    }, '>')
    .fromTo(mixerExitFlow, {
        strokeDashoffset: mixerExitFlow.getTotalLength()
    }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 5
    }, '>')
  return tl
}
function levels(){
  const tl = new gsap.timeline()
  tl.to([greenTankRect, blueTankRect, pinkTankRect], {
    attr: {y: gsap.utils.wrap([100, 195, 340])},
    duration: gsap.utils.wrap([12, 12, 12]),
    ease: 'linear'
  })
  .to(purpleTankRect, {
    attr: {y: 245},
    duration: 9,
    ease: 'linear'
  }, '')
  .call(removeElement(greenTankRect))
  .call(removeElement(blueTankRect))
  .call(removeElement(pinkTankRect))
  return tl
}
function reCirculation(){
  const tl = new gsap.timeline()
  tl.addLabel('startRecirculationLine')
    .fromTo(pump4Wings, {
        rotate: '0deg',
        transformOrigin: 'center center'
    }, {
        repeat: -1,
        duration: 2,
        rotate: '-360deg',
        ease: 'linear'
    })  

  .fromTo(purpleFlow, {
      strokeDasharray: "0 0",
      opacity: 0,
      duration: 0.5,
      attr: {
          d: "M615,320v34"
      }
    }, {
        opacity: 1,
        attr: {
            d: "M615,320v34"
        }
    }, 'startRecirculationLine+=1')
    .to(purpleFlow, {
        attr: {
            d: "M615,320v34h-81"
        },
        duration: 0.2
    }, '>')
    .to(purpleFlow, {
        attr: {
            d: "M615,320v34h-81v-9"
        },
        duration: 0.2
    }, '>')
    .to(purpleFlow, {
        attr: {
            d: "M615,320v34h-81v-9h-242"
        },
        strokeDasharray: '2 2',
        duration: 1
    }, '>')
    .to(purpleFlow, {
        attr: {
            d: "M615,320v34h-81v-9h-242v-123"
        },
        strokeDasharray: '2 2',
        duration: 1
    }, '>')
    .to(purpleFlow, {
        attr: {
            d: "M615,320v34h-81v-9h-242v-123h20"
        },
        duration: 0.5
    }, '>')
    .fromTo(purpleFlow, {
        strokeDashoffset: purpleFlow.getTotalLength()
    }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 10
    }, '>')
    return tl
}
function closeInputs(){
  const tl = new gsap.timeline()
  tl
    .addLabel('stopFlow')

    // M39 201v21h273
    // M39 220v2h273
    // M312 220v2h0
    .to(pump2Wings, {rotate: '360deg', overwrite: 'auto'})
    .to(blueFlow, {attr:{d: 'M39 222v0h273'}, duration: 0.5})
    .to(blueFlow, {attr:{d: 'M312 222v0h0'},  duration: 3})
    

    // M182 103v26h61v93h69
    // M182 127v2h61v93h69
    // M243 127v2h0v93h69
    // M243 218v2h0v2h69
    // M243 312v2h0v2h0
    .to(pump1Wings, {rotate: '360deg', overwrite: 'auto'}, 'stopFlow+=1')
    .to(greenFlow, {attr:{d: 'M182 129v0h61v93h69'}, duration: 0.5}, 'stopFlow+=0.4')
    .to(greenFlow, {attr:{d: 'M243 129v0h0v93h69'}, duration: 0.5}, '>')
    .to(greenFlow, {attr:{d: 'M243 220v0h0v2h69'}, duration: 0.5}, '>')
    .to(greenFlow, {attr:{d: 'M312 222v0h0v0h0'}, duration: 0.5}, '>')

    // M182 343v18h85v-139h45
    // M182 361v0h85v-139h45
    // M267 361v0h0v-139h45
    // M267 222v0h0v0h45
    // M312 222v0h0v0h0

    .to(pump3Wings, {rotate: '-360deg', overwrite: 'auto'}, 'stopFlow+=1.4')
    .to(pinkFlow, {attr:{d: 'M182 361v0h85v-139h45'}, duration: 0.5}, 'stopFlow+=1.4')
    .to(pinkFlow, {attr:{d: 'M267 361v0h0v-139h45'}, duration: 0.5}, '>')
    .to(pinkFlow, {attr:{d: 'M267 222v0h0v0h45'}, duration: 0.5}, '>')
    .to(pinkFlow, {attr:{d: 'M312 222v0h0v0h0'}, duration: 0.5}, '>')

    .call(removeElement(blueFlow))
    .call(removeElement(greenFlow))
    .call(removeElement(pinkFlow))

  return tl
}
function changingColors() {
    const tl = new gsap.timeline()
    tl.to([...linearGradientofFlowLines], {
      stopColor: finalColor,
      duration: 1
    })
    return tl
}
function fillingLine(){
  const  tl = new gsap.timeline()
  tl
  .fromTo(fillingLineT, {
    opacity: 0,
    y: -10
  }, {
    y: 0,
    opacity: 1,
    duration: 0.5,
    ease: 'sine'
  })
  .fromTo(exitFillFlow, {
    strokeDasharray: "0 0",
    opacity: 0,
    attr: {
        d: "M590.5 354"
    }
  }, {
      opacity: 1,
      attr: {
          d: "M590.5 354v32"
      },
      strokeDasharray: '2 2',
      duration: 1,
  })
  .fromTo(exitFillFlow, {
      strokeDashoffset: exitFillFlow.getTotalLength()
  }, {
      strokeDashoffset: 0,
      ease: 'linear',
      repeat: -1,
      duration: 5
  }, '>')
  return tl
}

const master = new gsap.timeline()
master
.add(setThings)
.add(entry)
// .add(pipeCreations, "+=3")
.add(pipeAppearance, '-=0.5')
.add(pumpStarts, '+=0')
.add(flowStart, "+=2")
.add(mixingLines, "+=4")
.add(exitFlow, "+=4")
.add(levels, '+=2')
.add(closeInputs, '+=10.5')
.add(reCirculation, "-=0.8")
.add(changingColors, '+=4')
.add(fillingLine, '+=2')